// src/pages/TermsAndConditionsSolCont.jsx
import React from "react";

const TermsScreen = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 flex flex-col">
      <main className="flex-1 max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 md:p-8">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4">
            Términos y Condiciones de Servicio – SolCont MX
          </h2>
          <p className="text-sm text-slate-600 mb-6">
            Al contratar, utilizar o solicitar cualquiera de los servicios de
            SolCont MX, el Cliente acepta íntegramente los presentes Términos y
            Condiciones, los cuales constituyen un contrato de prestación de
            servicios profesionales conforme a las leyes aplicables en México,
            incluyendo la legislación civil, mercantil y en materia de protección
            de datos personales.
          </p>

          {/* 1. Aceptación */}
          <section id="aceptacion" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              1. Aceptación de los Términos
            </h3>
            <p className="text-sm leading-relaxed text-slate-700">
              Al utilizar nuestros servicios, el Cliente declara que:
            </p>
            <ul className="mt-2 list-disc list-inside text-sm text-slate-700 space-y-1">
              <li>Ha leído y comprendido los presentes Términos y Condiciones.</li>
              <li>
                Acepta que SolCont MX actúa como prestador de servicios
                profesionales de asesoría y gestión contable, fiscal y
                administrativa.
              </li>
              <li>
                Reconoce que la veracidad, integridad y oportunidad de la
                información proporcionada es responsabilidad exclusiva del
                Cliente.
              </li>
            </ul>
          </section>

          {/* 2. Obligaciones del Cliente */}
          <section id="obligaciones-cliente" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              2. Obligaciones del Cliente
            </h3>
            <p className="text-sm text-slate-700 mb-2">
              El Cliente se compromete a:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1">
              <li>
                Proporcionar información veraz, completa y actualizada, incluyendo
                datos fiscales, documentación soporte y comprobantes digitales
                (CFDI).
              </li>
              <li>
                Entregar la documentación requerida en tiempo y forma, sin
                retrasos que impidan el cumplimiento oportuno de obligaciones
                fiscales.
              </li>
              <li>
                Mantener una comunicación respetuosa, clara y profesional con el
                personal de SolCont MX.
              </li>
              <li>
                Pagar puntualmente los honorarios acordados por los servicios
                contratados.
              </li>
              <li>
                No utilizar los servicios con fines fraudulentos, ilícitos o en
                perjuicio de terceros o de SolCont MX.
              </li>
            </ul>
          </section>

          {/* 3. Conducta malintencionada */}
          <section id="conducta-malintencionada" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              3. Conducta malintencionada o fraudulenta
            </h3>
            <p className="text-sm text-slate-700 mb-2">
              Con el fin de proteger la integridad de SolCont MX, se considera
              conducta malintencionada, de forma enunciativa mas no limitativa:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1">
              <li>
                Proporcionar deliberadamente información falsa, alterada o
                incompleta.
              </li>
              <li>
                Solicitar la manipulación de cifras, registros o información
                contable o fiscal para aparentar una situación distinta a la real.
              </li>
              <li>
                Negarse reiteradamente a entregar documentación indispensable para
                presentar declaraciones o cumplir obligaciones.
              </li>
              <li>
                Realizar acusaciones infundadas, amenazas o señalamientos que
                pongan en riesgo la integridad personal o profesional del
                despacho.
              </li>
              <li>
                Ejecutar contracargos, rechazo de pagos o cualquier mecanismo
                para eludir el pago de honorarios una vez prestado el servicio.
              </li>
            </ul>
            <p className="text-sm text-slate-700 mt-2">
              Ante la detección de conductas malintencionadas, SolCont MX se
              reserva el derecho de:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1 mt-1">
              <li>Suspender o cancelar inmediatamente los servicios.</li>
              <li>
                Rescindir el contrato de prestación de servicios sin obligación
                de reembolso.
              </li>
              <li>
                Emprender las acciones legales que estime pertinentes para la
                defensa de sus derechos, con fundamento en la legislación civil y
                mercantil aplicable en México.
              </li>
            </ul>
          </section>

          {/* 4. Facturación */}
          <section id="facturacion" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              4. Facturación y comprobantes fiscales
            </h3>
            <p className="text-sm text-slate-700">
              SolCont MX emitirá CFDI (factura electrónica) únicamente cuando:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1 mt-2">
              <li>Se haya recibido el pago correspondiente a los honorarios.</li>
              <li>
                El Cliente haya proporcionado correctamente sus datos fiscales
                (RFC, régimen, domicilio fiscal y demás requeridos).
              </li>
            </ul>

            {/* 4.1 Esquema de pagos a mes caído */}
            <p className="text-sm text-slate-700 mt-3">
              Los servicios de SolCont MX se prestan bajo un esquema de{" "}
              <strong>mes caído</strong>, por lo que:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1 mt-2">
              <li>
                El pago de los honorarios correspondientes a un mes de servicio
                deberá efectuarse a más tardar al momento de la entrega de la
                declaración y/o trabajos relativos al mes inmediato anterior.
              </li>
              <li>
                En caso de que el Cliente solicite la cancelación del servicio,
                se realizará un cálculo prorrateado de los honorarios del mes en
                curso con base en el trabajo ya realizado hasta la fecha de
                solicitud, monto que deberá ser cubierto por el Cliente.
              </li>
            </ul>

            <p className="text-sm text-slate-700 mt-3">
              En caso de no realizar el pago correspondiente dentro de los{" "}
              <strong>5 (cinco) días naturales</strong> siguientes a la entrega de
              la declaración, de los papeles de trabajo y/o de la emisión del CFDI
              de honorarios:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1 mt-2">
              <li>
                SolCont MX podrá suspender temporalmente la prestación de los
                servicios sin responsabilidad alguna por las consecuencias
                fiscales, administrativas o económicas que se generen durante el
                periodo de suspensión.
              </li>
              <li>
                Podrá, en su caso, aplicar un cargo administrativo por
                reactivación del servicio y/o exigir el pago total de los
                importes vencidos antes de reanudar cualquier trabajo adicional.
              </li>
            </ul>

            <p className="text-sm text-slate-700 mt-3">
              La solicitud extemporánea de facturación podrá generar ajustes
              administrativos; SolCont MX no será responsable de implicaciones
              fiscales derivadas de la emisión tardía de comprobantes cuando el
              retraso sea atribuible al Cliente, de conformidad con la legislación
              fiscal vigente.
            </p>
          </section>

          {/* 5. Limitación de responsabilidad */}
          <section id="limitacion-responsabilidad" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              5. Limitación de responsabilidad
            </h3>
            <p className="text-sm text-slate-700 mb-2">
              SolCont MX no será responsable por:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1">
              <li>
                Multas, recargos, actualizaciones o sanciones derivadas de
                información entregada tarde, incompleta o incorrecta por parte del
                Cliente.
              </li>
              <li>
                Consecuencias derivadas de decisiones financieras, administrativas
                o fiscales tomadas por el Cliente sin consultar o en contra de la
                recomendación profesional.
              </li>
              <li>
                Fallas, caídas o problemas en plataformas externas como SAT,
                IMSS, INFONAVIT, bancos, sistemas gubernamentales u otros ajenos
                al control de SolCont MX.
              </li>
            </ul>
            <p className="text-sm text-slate-700 mt-2">
              La responsabilidad de SolCont MX se limita exclusivamente al ámbito
              de los servicios contratados y hasta por el monto de los honorarios
              efectivamente pagados, en términos del marco jurídico aplicable.
            </p>
          </section>

          {/* 6. Rescisión */}
          <section id="rescisión" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              6. Rescisión del contrato de prestación de servicios
            </h3>
            <p className="text-sm text-slate-700 mb-2">
              SolCont MX se reserva el derecho de rescindir, en cualquier
              momento, el contrato de prestación de servicios cuando:
            </p>
            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1">
              <li>
                El Cliente viole los presentes Términos y Condiciones o cualquier
                acuerdo específico por escrito.
              </li>
              <li>
                Se identifique conducta malintencionada, fraude, abuso del
                servicio o riesgo a la integridad personal o profesional del
                despacho.
              </li>
              <li>
                Se presente falta de pago de honorarios por más de 30 días
                naturales.
              </li>
              <li>
                Existan faltas de respeto, agresiones, amenazas o cualquier forma
                de violencia hacia el personal de SolCont MX.
              </li>
            </ul>
            <p className="text-sm text-slate-700 mt-2">
              En caso de rescisión, se suspenderán inmediatamente los servicios;
              no habrá obligación de reembolsar pagos ya realizados y solo se
              entregará información o papeles de trabajo al Cliente en la medida
              en que no exista adeudo pendiente, conforme a lo previsto en el
              Código de Comercio y demás disposiciones aplicables.
            </p>
          </section>

          {/* 7. Confidencialidad */}
          <section id="confidencialidad" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              7. Confidencialidad, Protección de Datos y Aviso de Privacidad
            </h3>

            <p className="text-sm text-slate-700 mb-2">
              SolCont MX cumple con la{" "}
              <strong>
                Ley Federal de Protección de Datos Personales en Posesión de los
                Particulares (LFPDPPP)
              </strong>
              , así como con su Reglamento y demás normatividad aplicable en
              México en materia de privacidad.
            </p>

            <p className="text-sm text-slate-700 mb-2">
              Toda la información proporcionada por el Cliente será tratada con
              estricta confidencialidad y únicamente será utilizada para la
              prestación de los servicios contratados. La información personal,
              fiscal o contable solo será compartida en los siguientes casos:
            </p>

            <ul className="list-disc list-inside text-sm text-slate-700 space-y-1">
              <li>A petición expresa del Cliente.</li>
              <li>
                Cuando sea requerida por una autoridad competente conforme a
                derecho.
              </li>
              <li>
                Cuando sea necesario para la correcta prestación del servicio,
                incluyendo auxiliares contables o colaboradores sujetos a acuerdos
                de confidencialidad.
              </li>
            </ul>

            <p className="text-sm text-slate-700 mt-3">
              Para más información sobre el tratamiento de datos personales,
              finalidades, derechos ARCO y mecanismos de ejercicio, puede
              consultar nuestro
              <a
                href="/privacidad"
                className="text-sky-600 font-medium hover:underline ml-1"
              >
                Aviso de Privacidad
              </a>
              .
            </p>
          </section>

          {/* 8. Modificaciones */}
          <section id="modificaciones" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              8. Modificaciones a los Términos y Condiciones
            </h3>
            <p className="text-sm text-slate-700">
              SolCont MX podrá actualizar o modificar estos Términos y
              Condiciones en cualquier momento. Las versiones actualizadas se
              publicarán en los canales oficiales de SolCont MX y entrarán en
              vigor a partir de su publicación. El uso continuo de los servicios
              implica la aceptación de las modificaciones.
            </p>
          </section>

          {/* 9. Jurisdicción */}
          <section id="jurisdiccion" className="mb-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              9. Jurisdicción y ley aplicable
            </h3>
            <p className="text-sm text-slate-700">
              Para la interpretación y cumplimiento de los presentes Términos y
              Condiciones, las partes se someten a las leyes aplicables en los
              Estados Unidos Mexicanos y a la jurisdicción de los tribunales
              competentes de la ciudad de Tehuacán, Puebla, renunciando a
              cualquier otro fuero que pudiera corresponderles por razón de su
              domicilio presente o futuro, con fundamento en la legislación
              civil y mercantil vigente.
            </p>
          </section>

          {/* 10. Aceptación */}
          <section
            id="aceptacion-final"
            className="mt-8 border-t border-slate-200 pt-4"
          >
            <p className="text-sm text-slate-700">
              Al usar y contratar nuestros servicios, enviar documentación
              fiscal o continuar interactuando con cualquiera de las
              plataformas, canales de comunicación o procesos de SolCont MX, el
              Cliente reconoce que ha leído, comprendido y aceptado estos
              Términos y Condiciones en su totalidad.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <span className="text-xs text-slate-500">
            © {new Date().getFullYear()} SolCont MX. Todos los derechos
            reservados.
          </span>
          <span className="text-xs text-slate-400">
            Última actualización: 01 de enero de 2025
          </span>
        </div>
      </footer>
    </div>
  );
};

export default TermsScreen;
